import { Link } from 'react-router-dom';
import type { IExpenseRelatedLinksProps } from './types';
import { getRelatedLinkParams } from './utils';

export const ExpenseRelatedLinks = (props: IExpenseRelatedLinksProps) => {
  const params = getRelatedLinkParams(props);

  if (!params) return null;

  return <Link to={params.path}>{params.text}</Link>;
};
